var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 120,
    viewBox: "0 0 190 120",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14857_17115)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    width: 190,
    height: 120,
    rx: 2,
    transform: "matrix(-1 0 0 1 190 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114 62.5C114 66.7523 112.739 70.9091 110.377 74.4448C108.014 77.9804 104.656 80.7361 100.728 82.3634C96.7991 83.9907 92.4762 84.4165 88.3056 83.5869C84.135 82.7573 80.304 80.7096 77.2972 77.7028C74.2904 74.696 72.2427 70.865 71.4131 66.6944C70.5835 62.5238 71.0093 58.2009 72.6366 54.2723C74.2639 50.3437 77.0196 46.9859 80.5552 44.6234C84.0909 42.261 88.2477 41 92.5 41V62.5H114Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.5 36C99.4547 36 102.381 36.582 105.11 37.7127C107.84 38.8434 110.321 40.5008 112.41 42.5901C114.499 44.6794 116.157 47.1598 117.287 49.8896C118.418 52.6195 119 55.5453 119 58.5L96.5 58.5V36Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14857_17115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowCard);
export default __webpack_public_path__ + "static/media/FlowCard.b65faebdc0af2a8ee0b2738a0842d281.svg";
export { ForwardRef as ReactComponent };